import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/base.scss';
import base64 from '@/utils/exportBase64.js';
import { Toast } from 'mand-mobile';
import VueClipboard from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { i18n } from '@/lang';
import { globalMixins } from '@/mixins';
// import siteConfig from '@/siteConfig';

// 全局组件
import globalCom from './components/globalCom';

Vue.use(VueAwesomeSwiper);
Vue.use(VueClipboard);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: base64.errorPic,
  // loading: siteConfig.noData,
  attempt: 1
});
// 全局组件注册
globalCom.forEach(comp => {
  Vue.component(comp.name, comp);
});

// 全局mixins
Vue.mixin(globalMixins);

// 全局toast
Vue.prototype.$toast = Toast;
// 事件总线
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
  created () {
    // const userInfo = localStorage.getItem('userInfo');
    // const token = userInfo && JSON.parse(userInfo).token;

    // if (token && userInfo) {
    //   this.$store.dispatch('message/updateNIMInfo', JSON.parse(userInfo));
    // }
  }
}).$mount('#app');
